/**
 * 
 * Check if an email address already exists
 * 
 */
const emailCheckField = document.getElementById('emailCheck')
const myAyaUrl = document.querySelector('html').dataset.my || `my`
const requestOptions = { method: 'GET', redirect: 'follow' }
let emailField = document.getElementById('email')
let userEmail = ''

export function checkEmail(e) {
   e.preventDefault()
   let email = (emailCheckField.value).toLowerCase()

   // Check if the entered email is valid otherwise display an error
   if (email && /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email)) {
       userEmail = email
   } else {
       document.querySelector('.messages--emailcheck').innerHTML = '<span class="help has-error is-danger">Please enter a valid email</span>'
       return
   }

    // No user so show reg form
    // document.getElementById('register--check').classList.add('hide-el')
    // document.getElementById('register--login').classList.add('hide-el')
    // document.getElementById('register--get-started').classList.remove('hide-el')
    // emailField.value = userEmail

   // Hit the API to determine if the user already has an account
   fetch(`/wp-json/aya/v1/accountexists?userEmail=${encodeURIComponent(email)}`, requestOptions)
       .then(response => response.json())
       .then((result) => {
           if (result.exists === true) {
               // User exists so show login messaging
               document.getElementById('register--check').classList.add('hide-el')
               document.getElementById('register--get-started').classList.add('hide-el')
               document.getElementById('register--login').classList.remove('hide-el')
           } else {
               // No user so show reg form
               document.getElementById('register--check').classList.add('hide-el')
               document.getElementById('register--login').classList.add('hide-el')
               document.getElementById('register--get-started').classList.remove('hide-el')
               emailField.value = userEmail
           }
       })
       .catch(error => console.log('checkemail error', error));
}  



/**
* 
* A function to format text to look like a phone number
* 
*/
export function phoneFormat(input) {
   // Strip all characters from the input except digits
   input = input.replace(/\D/g, '');

   // Trim the remaining input to ten characters, to preserve phone number format
   input = input.substring(0, 10);

   // Based upon the length of the string, we add formatting as necessary
   var size = input.length;
   if (size == 0) {
       input = input;
   } else if (size < 4) {
       input = '(' + input;
   } else if (size < 7) {
       input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
   } else {
       input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + '-' + input.substring(6, 10);
   }
   return input;
}



/**
 * 
 * Format zip
 * 
 */
export function zipCodeFormat(country, input) {
    switch (country) {
        case "US": {
            input = input.replace(/\D/g, '');
            input = input.substring(0, 5);
            break;
        }
        case "Canada": {
            input = input.replace(/[^a-zA-Z0-9]/g, '');
            input = input.substring(0, 6);
            input = input.toUpperCase();

            if (input.length > 3) {
                input = input.substring(0, 3) + " " + input.substring(3, 6)
            }
            break;
        }
    }

    return input;
}




/**
 * 
 * Sanitize zip
 * 
 */
export function sanitizeZip(zip) {
    let sanitizedZip = zip.replace(/[^a-zA-Z0-9\s]/g, '')
    return sanitizedZip
}



/**
* 
* Ensure password meets requirements
* 
*/
export function checkPassword() {
   let currValue = document.getElementById('password').value;
   let tooltipReqLength = document.querySelector('.pw-req--length')
   let tooltipReqNumber = document.querySelector('.pw-req--number')
   let tooltipReqUpper = document.querySelector('.pw-req--upper')
   let tooltipReqLower = document.querySelector('.pw-req--lower')
   let tooltipReqSymbol = document.querySelector('.pw-req--symbol')

   // At least 8 characters
   if (currValue.length < 8) {
       tooltipReqLength.classList.remove('pw-req--true')
       tooltipReqLength.classList.add('pw-req--false')
   } else {
       tooltipReqLength.classList.remove('pw-req--false')
       tooltipReqLength.classList.add('pw-req--true')
   }

   // 1 number
   if (currValue.search(/\d/) == -1) {
       tooltipReqNumber.classList.remove('pw-req--true')
       tooltipReqNumber.classList.add('pw-req--false')
   } else {
       tooltipReqNumber.classList.remove('pw-req--false')
       tooltipReqNumber.classList.add('pw-req--true')
   }

   // 1 uppercase
   if (currValue.search(/[A-Z]/) == -1) {
       tooltipReqUpper.classList.remove('pw-req--true')
       tooltipReqUpper.classList.add('pw-req--false')
   } else {
       tooltipReqUpper.classList.remove('pw-req--false')
       tooltipReqUpper.classList.add('pw-req--true')
   }

   // 1 lowercase
   if (currValue.search(/[a-z]/) == -1) {
       tooltipReqLower.classList.remove('pw-req--true')
       tooltipReqLower.classList.add('pw-req--false')
   } else {
       tooltipReqLower.classList.remove('pw-req--false')
       tooltipReqLower.classList.add('pw-req--true')
   }

   // 1 symbol
   if (currValue.search(/[!\[\]\{\}\\`~^;:'\"<>\?\|,\/@#\$%\^\&*\)\(+=._-]/) == -1) {
       tooltipReqSymbol.classList.remove('pw-req--true')
       tooltipReqSymbol.classList.add('pw-req--false')
   } else {
       tooltipReqSymbol.classList.remove('pw-req--false')
       tooltipReqSymbol.classList.add('pw-req--true')
   }
}



